/*
 *   Copyright (c) 2020
 *   All rights reserved.
 */

export const SET_USER = 'SET_USER';
export const GET_NOTIFICATIONS_CALL = 'GET_NOTIFICATIONS_CALL';
export const GET_NOTIFICATIONS_DONE = 'GET_NOTIFICATIONS_DONE';
export const GET_NOTIFICATIONS_SEEN = 'GET_NOTIFICATIONS_SEEN';
export const GET_NOTIFICATIONS_SEENING = 'GET_NOTIFICATIONS_SEENING';
export const GET_NOTIFICATIONS_HAVEREAD_CALL =
  'GET_NOTIFICATIONS_HAVEREAD_CALL';
export const GET_NOTIFICATIONS_ALL_HAVEREAD = 'GET_NOTIFICATIONS_ALL_HAVEREAD';
export const GET_NOTIFICATIONS_IO_CALL = 'GET_NOTIFICATIONS_IO_CALL';
export const GET_NOTIFICATIONS_IO_DONE = 'GET_NOTIFICATIONS_IO_DONE';
export const GET_BIND_CREDITCARD_INFO_CALL = 'GET_BIND_CREDITCARD_INFO_CALL';
export const GET_BIND_CREDITCARD_INFO_DONE = 'GET_BIND_CREDITCARD_INFO_DONE';
export const DELETE_BIND_CREDITCARD_INFO_CALL =
  'DELETE_BIND_CREDITCARD_INFO_CALL';
export const DELETE_BIND_CREDITCARD_INFO_DONE =
  'DELETE_BIND_CREDITCARD_INFO_DONE';
export const REBIND_CREDITCARD_INFO_CALL = 'REBIND_CREDITCARD_INFO_CALL';
export const REBIND_CREDITCARD_INFO_DONE = 'REBIND_CREDITCARD_INFO_DONE';
export const LOCK_ACTION_CREDITCARD_CALL = 'LOCK_ACTION_CREDITCARD_CALL';
export const GET_INVOICE_LIST_CALL = 'GET_INVOICE_LIST_CALL';
export const GET_INVOICE_LIST_DOEN = 'GET_INVOICE_LIST_DOEN';
export const MODIFY_INVOICE_INC_NUMBER_CALL = 'MODIFY_INVOICE_INC_NUMBER_CALL';
export const MODIFY_INVOICE_INC_NUMBER_DOEN = 'MODIFY_INVOICE_INC_NUMBER_DOEN';
export const DOWNLOAD_INVOICE_CALL = 'DOWNLOAD_INVOICE_CALL';
export const DOWNLOAD_INVOICE_DOEN = 'DOWNLOAD_INVOICE_DOEN';
export const GET_USER_CURRENT_PLAN_CALL = 'GET_USER_CURRENT_PLAN_CALL';
export const GET_USER_CURRENT_PLAN_DOEN = 'GET_USER_CURRENT_PLAN_DOEN';
export const DELETE_USER_TRIAL_PLAN_CALL = 'DELETE_USER_TRIAL_PLAN_CALL';
export const DELETE_USER_TRIAL_PLAN_DOEN = 'DELETE_USER_TRIAL_PLAN_DOEN';
export const PUT_USER_PLAN_CALL = 'PUT_USER_PLAN_CALL';
export const PUT_USER_PLAN_DOEN = 'PUT_USER_PLAN_DOEN';
export const CANCEL_USER_PLAN_CALL = 'CANCEL_USER_PLAN_CALL';
export const CANCEL_USER_PLAN_DOEN = 'CANCEL_USER_PLAN_DOEN';
export const OPINION_USER_PLAN_CALL = 'OPINION_USER_PLAN_CALL';
export const OPINION_USER_PLAN_DOEN = 'OPINION_USER_PLAN_DOEN';
export const CHANGE_USER_FORMAL_PLAN_CALL = 'CHANGE_USER_FORMAL_PLAN_CALL';
export const CHANGE_USER_FORMAL_PLAN_DOEN = 'CHANGE_USER_FORMAL_PLAN_DOEN';
export const PUT_USER_PROFILE_PICTURE_CALL = 'PUT_USER_PROFILE_PICTURE_CALL';
export const PUT_USER_PROFILE_PICTURE_DONE = 'PUT_USER_PROFILE_PICTURE_DONE';
export const PUT_USER_PROFILE_PICTURE_FAIL = 'PUT_USER_PROFILE_PICTURE_FAIL';
export const PUT_USER_PROFILE_PICTURE_RESET = 'PUT_USER_PROFILE_PICTURE_RESET';
export const PUT_USER_PROFILE_CALL = 'PUT_USER_PROFILE_CALL';
export const PUT_USER_PROFILE_DONE = 'PUT_USER_PROFILE_DONE';
export const PUT_USER_PROFILE_FAIL = 'PUT_USER_PROFILE_FAIL';
export const PUT_PROFILE_MOBILE_CALL = 'PUT_PROFILE_MOBILE_CALL';
export const PUT_PROFILE_MOBILE_STATUS_CALL = 'PUT_PROFILE_MOBILE_STATUS_CALL';
export const VERIFICATION_PROFILE_MOBILE_STATUS_CALL =
  'VERIFICATION_PROFILE_MOBILE_STATUS_CALL';
export const VERIFICATION_PROFILE_MOBILE_STATUS_DOEN =
  'VERIFICATION_PROFILE_MOBILE_STATUS_DOEN';
export const PUT_PROFILE_PASSWORD_CALL = 'PUT_PROFILE_PASSWORD_CALL';
export const PUT_PROFILE_PASSWORD_DOEN = 'PUT_PROFILE_PASSWORD_DOEN';
export const PUT_PROFILE_PASSWORD_FAIL = 'PUT_PROFILE_PASSWORD_FAIL';
export const BIND_USER_EMAIL_CALL = 'BIND_USER_EMAIL_CALL';
export const BIND_USER_EMAIL_DONE = 'BIND_USER_EMAIL_DONE';
export const BIND_USER_EMAIL_FAIL = 'BIND_USER_EMAIL_FAIL';
export const GET_BIND_USER_EMAIL_VERIFICATION_CALL =
  'GET_BIND_USER_EMAIL_VERIFICATION_CALL';
export const GET_VERIFICATION_USER_EMAIL_CALL =
  'GET_VERIFICATION_USER_EMAIL_CALL';

export const GET_USER_PROFILE_CALL = 'GET_USER_PROFILE_CALL';
export const GET_USER_PROFILE_DONE = 'GET_USER_PROFILE_DONE';
export const GET_USER_PROFILE_FAIL = 'GET_USER_PROFILE_FAIL';

export const BIND_OTHER_USERNAME_CALL = 'BIND_OTHER_USERNAME_CALL';
export const BIND_OTHER_USERNAME_DONE = 'BIND_OTHER_USERNAME_DONE';
export const BIND_OTHER_USERNAME_FAIL = 'BIND_OTHER_USERNAME_FAIL';

export const UNBIND_OTHER_USERNAME_CALL = 'UNBIND_OTHER_USERNAME_CALL';
export const UNBIND_OTHER_USERNAME_DONE = 'UNBIND_OTHER_USERNAME_DONE';
export const UNBIND_OTHER_USERNAME_FAIL = 'UNBIND_OTHER_USERNAME_FAIL';

export const GET_LEARNING_CENTER_CALL = 'GET_LEARNING_CENTER_CALL';
export const GET_LEARNING_CENTER_DONE = 'GET_LEARNING_CENTER_DONE';
export const GET_LEARNING_CENTER_FAIL = 'GET_LEARNING_CENTER_FAIL';

export const GET_LEARNING_CENTER_ASSIGN_COURSE_CALL = 'GET_LEARNING_CENTER_ASSIGN_COURSE_CALL';
export const GET_LEARNING_CENTER_ASSIGN_COURSE_DONE = 'GET_LEARNING_CENTER_ASSIGN_COURSE_DONE';
export const GET_LEARNING_CENTER_ASSIGN_COURSE_FAIL = 'GET_LEARNING_CENTER_ASSIGN_COURSE_FAIL';

export const GET_LEARNING_CENTER_LEARNING_PATH_CALL = 'GET_LEARNING_CENTER_LEARNING_PATH_CALL';
export const GET_LEARNING_CENTER_LEARNING_PATH_DONE = 'GET_LEARNING_CENTER_LEARNING_PATH_DONE';
export const GET_LEARNING_CENTER_LEARNING_PATH_FAIL = 'GET_LEARNING_CENTER_LEARNING_PATH_FAIL';

export const GET_USER_JOINED_COURSES_STATISTICS_CALL = 'GET_USER_JOINED_COURSES_STATISTICS_CALL';
export const GET_USER_JOINED_COURSES_STATISTICS_DONE = 'GET_USER_JOINED_COURSES_STATISTICS_DONE';
export const GET_USER_JOINED_COURSES_STATISTICS_FAIL = 'GET_USER_JOINED_COURSES_STATISTICS_FAIL';

export const GET_USER_JOINED_LEARNING_PATH_STATISTICS_CALL = 'GET_USER_JOINED_LEARNING_PATH_STATISTICS_CALL';
export const GET_USER_JOINED_LEARNING_PATH_STATISTICS_DONE = 'GET_USER_JOINED_LEARNING_PATH_STATISTICS_DONE';
export const GET_USER_JOINED_LEARNING_PATH_STATISTICS_FAIL = 'GET_USER_JOINED_LEARNING_PATH_STATISTICS_FAIL';

export const RESET_USER_LEARNING_PATH_STATISTICS_CALL = 'RESET_USER_LEARNING_PATH_STATISTICS_CALL';
export const GET_USER_LEARNING_PATH_STATISTICS_CALL = 'GET_USER_LEARNING_PATH_STATISTICS_CALL';
export const GET_USER_LEARNING_PATH_STATISTICS_DONE = 'GET_USER_LEARNING_PATH_STATISTICS_DONE';
export const GET_USER_LEARNING_PATH_STATISTICS_FAIL = 'GET_USER_LEARNING_PATH_STATISTICS_FAIL';

export const GET_LEARNING_RECORDS_MINE_CALL = 'GET_LEARNING_RECORDS_MINE_CALL';
export const GET_LEARNING_RECORDS_MINE_DONE = 'GET_LEARNING_RECORDS_MINE_DONE';
export const GET_LEARNING_RECORDS_MINE_FAIL = 'GET_LEARNING_RECORDS_MINE_FAIL';

export const GET_LEARNING_LEVEL_CALL = 'GET_LEARNING_LEVEL_CALL';
export const GET_LEARNING_LEVEL_DONE = 'GET_LEARNING_LEVEL_DONE';
export const GET_LEARNING_LEVEL_FAIL = 'GET_LEARNING_LEVEL_FAIL';

export const POST_USER_LANGUAGE_CALL = 'POST_USER_LANGUAGE_CALL';
export const POST_USER_LANGUAGE_DONE = 'POST_USER_LANGUAGE_DONE';
export const POST_USER_LANGUAGE_FAIL = 'POST_USER_LANGUAGE_FAIL';
